// Copyright (c) 2017 Deere & Company

export const auditListSortOptions = [
    {
        displayName: 'DUE_DATE',
        path: ['dueDate']
    },
    {
        displayName: 'DEALERSHIP',
        path: ['leadAccountName']
    },
    {
        displayName: 'CITY',
        path: ['city']
    },
    {
        displayName: 'STATE',
        path: ['state']
    },
    {
        displayName: 'ACCOUNT',
        path: ['leadAccount']
    },
    {
        displayName: 'ROLLING_12_CREDIT_AMOUNT',
        path: ['rolling12MonthsCredit']
    }
];



// WEBPACK FOOTER //
// ./src/tcsm/audits/helpers/audit-list-sort-options.js